/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum PayStatus {
    NotRated = 0,
    Rated = 100,
    ReadyToPrint = 110,
    ReadyToPost = 115,
    Posted = 120,
}
